export default __webpack_public_path__ + "static/media/bgBlue300x400.f8cf0fe0.jpg";